import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
    standalone: true,
    imports: [CommonModule],
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: '[skeleton]',
    templateUrl: './skeleton.component.html'
})
export class SkeletonComponent implements OnInit {
    @Input() repeat = 1;
    @Input() skeletonClasses = '';

    repeatArr = [];

    ngOnInit(): void {
        this.repeatArr = Array(this.repeat);
    }
}
